import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { Card } from '@/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

const ROWS = 8
// One width per grid column: Status, Number, Rev, Title, Spec section, Category,
// Discipline, Company, Package, Responsible, Due date, Review.
const COLUMN_WIDTHS = ['w-16', 'w-14', 'w-8', 'w-32', 'w-20', 'w-20', 'w-20', 'w-24', 'w-20', 'w-24', 'w-16', 'w-10']

const SubmittalsListSkeleton: React.FC = () => {
  return (
    <Card className="shadow-sm border-0">
      {/* Toolbar: stats + filter bar (5 selects + filter button + search) + New button */}
      <div className="py-2 flex items-center gap-3 flex-wrap">
        <Skeleton className="h-7 w-10" />
        <Skeleton className="h-4 w-12" />
        <div className="flex-1 min-w-0 flex items-center gap-2 flex-wrap">
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-36" />
          <Skeleton className="h-8 w-8" />
        </div>
        <Skeleton className="h-8 w-32" />
      </div>

      {/* Tabs: Items | Packages | Spec sections */}
      <Skeleton className="h-10 w-72 rounded-lg mb-3" />

      {/* Grid */}
      <div className="rounded-md border border-border overflow-hidden bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              {COLUMN_WIDTHS.map((w, i) => (
                <TableHead key={i}>
                  <Skeleton className={`h-3 ${w}`} />
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: ROWS }).map((_, i) => (
              <TableRow key={i}>
                {COLUMN_WIDTHS.map((_, j) => (
                  <TableCell key={j}>
                    {j === 0 ? <Skeleton className="h-5 w-20 rounded-full" /> : <Skeleton className="h-4 w-16" />}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  )
}

export default SubmittalsListSkeleton
